import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { AppModule, msalInstance } from '../../app.module';
import { BehaviorSubject } from 'rxjs';
import { PublicClientApplication, AccountInfo } from "@azure/msal-browser";

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private baseUrl = environment.baseUrl;
  //msalInstance: any;
  private usernameSource = new BehaviorSubject<string | null>(null);
  username$ = this.usernameSource.asObservable();
  private msalInstance: PublicClientApplication | null = null;

  constructor(private http: HttpClient) { }

  private async initMSAL(): Promise<PublicClientApplication> {
    if (!this.msalInstance) {
      this.msalInstance=new PublicClientApplication({
  auth: {
    clientId: 'a3b2a75e-d054-4da5-9b74-966dcb2d3463',
    authority: 'https://login.microsoftonline.com/44060820-ecc9-4366-b97e-0db725e356db',
    redirectUri: 'http://localhost:4200/timesheet-n',
     //redirectUri: 'https://alloc8-ui.local/timesheet-n',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  }
});
      await msalInstance.initialize();
    }
    return msalInstance;
  }

  async loginWithSSO() {
    const instance = await this.initMSAL();

    const response = await instance.loginPopup({
      scopes: ['user.read']
    });

    instance.setActiveAccount(response.account);

    localStorage.setItem('loginType', 'sso');

    return response;
  }

   async restoreSSOSession(): Promise<AccountInfo | null> {
    const instance = await this.initMSAL();

    await instance.handleRedirectPromise();

    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
      return accounts[0];
    }

    return null;
  }

  //original
  // async loginWithSSO() {
  //   if (!(msalInstance as any)._isInitialized) {   
  //     await msalInstance.initialize();
  //     (msalInstance as any)._isInitialized = true; // mark initialized
  //   }

  //   return msalInstance.loginPopup({
  //     scopes: ['user.read']
  //   });
  // }

  login(username: string, password: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/Login/register`, { username, password });
  }

  changePassword(username: string, password: string): Observable<any> {
    console.log(username, password);  
  return this.http.post<any>(`${this.baseUrl}/Login/change-password`, { username, password });
  }  

  setUsername(username: string) {
    localStorage.setItem('userNameWithoutSSO', username);
    this.usernameSource.next(username);
  }

  loadFromStorage() {
    const saved = localStorage.getItem('userNameWithoutSSO');
    if (saved) {
      this.usernameSource.next(saved);
    }
  }

  getUsername(username: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/User/get-by-username/${username}`);
  }

  createLoginHistory(model: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/User/CreateLoginHistory`, model);
  }

  handlePostSSOLogin(account: any): void {

    const model = {
      employeeId: 'INITIAL LOGIN',
      employeeName: account.name,
      employeeMail: account.username,
      profileJson: JSON.stringify({account}),
      loginType: 'SSO'
    };

    this.createLoginHistory(model).subscribe({
      error: () => { }
    });
  }
}
